const PEXELS_HOST = 'images.pexels.com';
const SRCSET_WIDTHS = [400, 600, 800, 1200];

function isPexelsUrl(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    return new URL(url).hostname === PEXELS_HOST;
  } catch {
    return false;
  }
}

export function optimizeImage(url, width = 600) {
  if (!url || typeof url !== 'string') return '';
  if (!isPexelsUrl(url)) return url;
  const base = url.split(/[?#]/)[0];
  return `${base}?auto=compress&cs=tinysrgb&w=${width}`;
}

export function generateSrcSet(url, widths = SRCSET_WIDTHS) {
  if (!isPexelsUrl(url)) return undefined;
  return widths
    .map((width) => `${optimizeImage(url, width)} ${width}w`)
    .join(',');
}